import React from 'react';
import { LANGUAGES } from '../../../static/region-data';
import { FiSearch, FiCheck, FiGlobe } from 'react-icons/fi';
import { MdLanguage } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

const LanguageTab = ({ pendingLang, setPendingLang }) => {
  const { t } = useTranslation();
  const selected = LANGUAGES.find((l) => l.code === pendingLang);

  return (
    <div className="flex flex-col gap-3">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {LANGUAGES.map((lang) => {
          const isSelected = lang.code === pendingLang;
          return (
            <button
              key={lang.code}
              onClick={() => setPendingLang(lang.code)}
              className={`relative flex flex-col items-center gap-1 px-2 py-3 rounded-2xl text-center transition-all
                ${
                  isSelected
                    ? 'bg-red-600/20 border-2 border-red-600'
                    : 'bg-white/[0.03] border-2 border-transparent hover:bg-white/8 hover:border-white/20'
                }`}
            >
              {isSelected && (
                <span className="absolute top-1.5 right-1.5 w-4 h-4 rounded-full bg-red-600 flex items-center justify-center">
                  <FiCheck size={9} className="text-white" />
                </span>
              )}
              <span className="text-2xl leading-none">{lang.flag}</span>
              <span
                className={`text-xs font-black tracking-widest uppercase ${isSelected ? 'text-red-400' : 'text-gray-600'}`}
              >
                {lang.code}
              </span>
              <span
                className={`text-xs font-semibold ${isSelected ? 'text-white' : 'text-gray-400'}`}
              >
                {lang.name}
              </span>
              <span
                className={`text-xs ${isSelected ? 'text-gray-400' : 'text-gray-700'}`}
                dir={lang.dir}
              >
                {lang.native}
              </span>
            </button>
          );
        })}
      </div>

      {/* RTL notice */}
      {selected?.dir === 'rtl' && (
        <div className="flex items-start gap-2 bg-amber-500/10 border border-amber-500/20 rounded-xl px-3 py-2.5">
          <MdLanguage className="text-amber-400 shrink-0 mt-0.5" size={14} />
          <p className="text-xs text-amber-300 leading-relaxed">
            {t('regionLanguage.language.rtlNotice')}
          </p>
        </div>
      )}
    </div>
  );
};

export default LanguageTab;
